import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SUB_TYPE } from 'src/app/core/Constants/static';
import { AlertInfo } from 'src/app/core/Models/interfaces/alert&toast';
import { PrescriptionResponse, CapValidation } from 'src/app/core/Models/interfaces/prescriptionResponse';
import { ApiResponse, HeaderInfo, Prescription } from 'src/app/core/Models/interfaces/responseData';
import { UserService } from 'src/app/core/Services/user.service';
import { UtilityService } from 'src/app/core/Services/utility.service';
import { PrescriptionService } from 'src/app/features/prescription/prescription.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-common-details-view',
  templateUrl: './common-details-view.component.html',
  styleUrls: ['./common-details-view.component.css']
})
export class CommonDetailsViewComponent implements OnInit {

  @ViewChild('leftTable') leftTable!: ElementRef<HTMLElement>;
  @ViewChild('rightTable') rightTable!: ElementRef<HTMLElement>;

  public batchId!: string
  public currentActivity: number = 0;
  public headerInfo: HeaderInfo | null = null;
  public prescription: Prescription | null = null;
  public fetchingInProgress: boolean = false;
  public totalResponse: boolean = true;
  public activeTab: number = 1;
  public prescriptionResponse!: PrescriptionResponse[];
  public showDetails: boolean = false;
  public showLess: boolean = false;
  public count: number = 6;
  public description: string[] = []
  public isStatusUpdated: boolean[] = [false];
  public capPrescriptionResponse!: CapValidation[]
  public isCapValidionOpen: boolean = false;
  public header: string = '';
  public subTypes = SUB_TYPE;
  public subTypeEvm = environment?.subscriberType ? environment?.subscriberType : this.subTypes.both;
  public show = false;
  public capLock = false;


  constructor(
    private prescriptionService: PrescriptionService,
    private toasterandLoader: ToasterService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private utility : UtilityService
  ) { }

  private getRequestId(): void {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.batchId = id;
        this.lockView();
      }
    });
  }

  private getTransactionDetails(): void {
    this.fetchingInProgress = true;
    this.toasterandLoader.isLoaderEnable(true);
    this.prescriptionService.getTransactionDetails(this.batchId).subscribe({
      next: (response) => {
        if (response.data.request) {
          this.headerInfo = response.data.request.headers;
          this.prescription = response.data.request.prescription;
          if (this.headerInfo == null && this.prescription == null) {
            this.totalResponse = false;
          }
          this.prescriptionResponse = response?.data?.response;
          this.capPrescriptionResponse = response?.data?.capPrescriptionResponse;
          this.prescriptionResponse.forEach((el: PrescriptionResponse) => {
            el.showDetails = false;
          })
          this.toasterandLoader.isLoaderEnable(false);
          this.fetchingInProgress = false;
        } else {
          this.show = false;
          this.toasterandLoader.isLoaderEnable(false);
        }
      },
      error: (error) => {
        this.toasterandLoader.isLoaderEnable(false);
      },
    })
  }

  public ngOnInit(): void {
    if (this.router.url.includes('/prescription/detail-view')) {
      this.header = 'Prescription'
    }
    if (this.router.url.includes('authorizations/detail-view')) {
      this.header = 'Authorizations'
    }
    this.getRequestId();
  }

  public closeThis(): void {
    if (this.show) {
      this.utility.unlockView('prescription',this.batchId,).subscribe()
    }
    let url = this.router.url;
    if (url) {
      if (url.includes('/prescription/detail-view')) {
        this.router.navigate(['prescription', 'prescriptionlist']);
      }
      if (url.includes('authorizations/detail-view')) {
        this.router.navigate(['authorizations', 'authorizationslist']);
      }
    }
  }

  public switchTab(tab: number): void {
    this.activeTab = tab;
  }

  public showItemDetails(item: PrescriptionResponse): void {
    item.showDetails = !item.showDetails;
  }

  public updateCount(isless: boolean): void {
    if (isless) {
      this.count = 6;
      this.showLess = false;
    } else {
      this.showLess = true;
      this.count = this.count + 10;
    }

  }

  public get name(): string {
    return `${this.prescription?.patient?.memberFirstName || ''} ${this.prescription?.patient?.memberMiddleName || ''} ${this.prescription?.patient?.memberLastName || ''}`
  }

  public clearComment(index: number): void {
    this.description[index] = '';
  }

  public checkValidationSataus(val: string): boolean {
    if (val.toLocaleLowerCase().trim() === 'success' || val.toLocaleLowerCase().trim() === 'pass') {
      return true;
    }
    else {
      return false;
    }
  }

  public addComment(event: string): boolean {
    if (event) {
      return false;
    } else {
      return true;
    }
  }

  public updateStatus(id: number | undefined, val: number, index: number): void {
    this.isStatusUpdated[index] = true;
    if (id && this.description[index]) {
      this.toasterandLoader.alert.confirm(
        {
          text: `Are you sure you want update the status ?`,
          type: 'warning',
          hideCancelButton: false,
          okText: 'Yes',
          cancelText: 'No',
          title: 'Warning!',
        }
      ).then((res) => {
        if (res) {
          this.toasterandLoader.isLoaderEnable(true);
          let payLoad = {
            actionFlag: val,
            approvalComment: this.description[index]
          };
          this.prescriptionService.setApprovalStatus(id, payLoad).subscribe({
            next: (response) => {
              if (response.status == 'Success') {
                let data = response.data;
                this.prescriptionResponse[index].activityApprovalStatus = data.actionFlag;
                this.prescriptionResponse[index].approvalComment = data.approvalComment;
                this.prescriptionResponse[index].isOverridden = data.isOverridden;
                this.toasterandLoader.alert.toast({
                  title: 'Success',
                  type: 'success',
                  message: 'Status Successfully Updated',
                });
              }
              this.toasterandLoader.isLoaderEnable(false);
              this.description[index] = '';
              this.isStatusUpdated[index] = false;
            },
            error: (error) => {
              this.toasterandLoader.isLoaderEnable(false);
              this.toasterandLoader.alert.toast({
                title: 'Error',
                type: 'error',
                message: error.message,
              });
              this.toasterandLoader.isLoaderEnable(false);
              this.description[index] = '';
              this.isStatusUpdated[index] = false;
            },
          });
          // this.getTransactionDetails();
        }
      })
    }
  }

  public settable(): void {
    setTimeout(() => {
      const leftRows = this.leftTable?.nativeElement.getElementsByTagName('tr');
      const rightRows = this.rightTable?.nativeElement.getElementsByTagName('tr');
      for (let i = 0; i < leftRows.length; i++) {
        const leftRowHeight = leftRows[i].offsetHeight;
        rightRows[i].style.height = leftRowHeight + 'px';
      }
    })
  }

  public setDrugName(res: PrescriptionResponse): string {
    if (res?.drugName === '' || res.drugName === null) {
      return res?.drugCode
    } else {
      return `${res.drugName} (${res.drugCode})`
    }
  }

  public toggleCap(): void {
    this.isCapValidionOpen = !this.isCapValidionOpen;
  }

  public handleScroll(event: Event): void {
    let currentScrollEle = event.target as HTMLElement
    if (currentScrollEle === this.leftTable.nativeElement) {
      this.rightTable.nativeElement.scrollTop = currentScrollEle.scrollTop;
    } else {
      this.leftTable.nativeElement.scrollTop = currentScrollEle.scrollTop;
    }
  }

  private checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

  private lockView() {
    this.utility.lockView('prescription',this.batchId).subscribe({
      next: (responce: ApiResponse) => {
        if (responce.data?.lock) {
          let tosData: any
          if (!this.checkPermission('takeOverTransaction')) {
            tosData = {
              text: responce.data.message,
              type: 'warning',
              hideCancelButton: false,
              hideOkButton: true,
              cancelText: 'Cancel',
              title: 'Warning!',
            }
          } else {
            tosData = {
              text: responce.data.message,
              type: 'warning',
              hideCancelButton: false,
              hideOkButton: false,
              okText: 'Take Over',
              cancelText: 'Cancel',
              title: 'Warning!',
            }
          }
          this.toasterandLoader.alert.confirm(
            tosData
          ).then((res) => {
            if (res) {
              this.utility.TekeOverView('prescription',this.batchId).subscribe({
                next: (res) => {
                  this.getTransactionDetails();
                  this.show = true;
                },
                error: (err) => {
                  this.closeThis();
                  this.toasterandLoader.alert.toast({
                    title: 'Error',
                    type: 'error',
                    message: err.message,
                  });
                }
              })
            } else {
              this.closeThis();
            }
          })

        } else {
          this.getTransactionDetails();
          this.show = true;
        }
      },
      error: (err) => {
        this.closeThis();
        this.toasterandLoader.alert.toast({
          title: 'Error',
          type: 'error',
          message: err.message
        });
      },
    })
  }

}
